import { Segmented } from 'antd';
import React from 'react';

const MappingType = ({ mappingType, onTypeChange }) => {
  const options = [
    {
      label: 'Non configuré',
      value: 'none',
    },
    {
      label: 'Mapping Simple',
      value: 'simple',
    },
    {
      label: 'Transformation Unique',
      value: 'unique',
    },
    {
      label: 'Chaîne de Transformations',
      value: 'chain',
    },
  ];

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'start',
        gap: 16,
        flexDirection: 'column',
      }}
    >
      <span style={{ fontSize: 16, fontWeight: 600 }}>Type de mapping</span>
      <Segmented
        options={options.map((option) => ({
          label: option.label,
          value: option.value,
        }))}
        onChange={onTypeChange}
        value={mappingType || 'none'}
      />
    </div>
  );
};

export default MappingType;
